import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/layout/Layout";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import DebtorsPage from "@/pages/DebtorsPage";
import DebtorDetailPage from "@/pages/DebtorDetailPage";
import BankConfigPage from "@/pages/BankConfigPage";
import ReceiptsPage from "@/pages/ReceiptsPage";
import AgendaPage from "@/pages/AgendaPage";
import TerminosPage from "@/pages/TerminosPage";
import AdminPage from "@/pages/AdminPage";
import ProfilePage from "@/pages/ProfilePage";
import QuotesPage from "@/pages/QuotesPage";
import EducacionPage from "@/pages/EducacionPage";
import PlanGate from "@/components/PlanGate";
import StatusGate from "@/components/StatusGate";
import LandingPage from "@/pages/LandingPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      {/* Toaster global: cubre /login, /register, /admin, /terminos y también las rutas dentro de Layout */}
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/terminos" element={<TerminosPage />} />

          {/* Admin panel — auth completamente independiente */}
          <Route
            path="/admin"
            element={
              <AdminAuthProvider>
                <AdminPage />
              </AdminAuthProvider>
            }
          />

          {/* App de usuarios normales */}
          <Route
            path="/*"
            element={
              <AuthProvider>
                <Routes>
                  <Route path="/landing" element={<LandingPage />} />
                  <Route path="/login" element={<AuthPage mode="login" />} />
                  <Route path="/register" element={<AuthPage mode="register" />} />
                  <Route
                    element={
                      <ProtectedRoute>
                        <StatusGate>
                          <Layout />
                        </StatusGate>
                      </ProtectedRoute>
                    }
                  >
                    <Route index element={<DashboardPage />} />
                    <Route path="/deudores" element={<DebtorsPage />} />
                    <Route path="/deudores/:id" element={<DebtorDetailPage />} />
                    <Route path="/agenda" element={<AgendaPage />} />
                    <Route
                      path="/cotizaciones"
                      element={
                        <PlanGate feature="cotizaciones">
                          <QuotesPage />
                        </PlanGate>
                      }
                    />
                    <Route
                      path="/comprobantes"
                      element={
                        <PlanGate feature="comprobantes">
                          <ReceiptsPage />
                        </PlanGate>
                      }
                    />
                    <Route path="/educacion" element={<EducacionPage />} />
                    <Route path="/perfil" element={<ProfilePage />} />
                    {/* Legacy alias: /recaudo ahora vive dentro de /perfil como pestaña */}
                    <Route path="/recaudo" element={<Navigate to="/perfil?tab=recaudo" replace />} />
                  </Route>
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </AuthProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
